module.exports = __webpack_public_path__ + "img/pop_dioa.18dee333.png";